import api from '../Api';
import { BaseService } from '../BaseService';

export class LocationsService extends BaseService {
    async getStates(): Promise<any[]> {
        try {
            return this.handleResponse(await api.get('locations/states'));
        } catch (e: any) {
            return this.catchHandler(e);
        }
    }

    async getCities(uf: string): Promise<any[]> {
        try {
            return this.handleResponse(await api.get(`locations/states/${uf}/cities`));
        } catch (e: any) {
            return this.catchHandler(e);
        }
    }
}
